<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
            
                            <div class="modal-header" style="justify-content: space-between;">
                                <div>
                                    <h4>{{ title  }}</h4>
                                </div>
                                <div>
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <i class="fas fa-times fa-2x"></i>
                                    </button>
                                </div>
                                
                            </div>
            
                            <div class="modal-body">
                                <!-- {{coordinates}} -->
                                <!-- <h4>Total Vehicles : {{marker.length}}</h4> -->
                                <!-- <span style="color:red" v-if="marker.length == 0">No Vehicle Found!</span> -->

                                <GmapMap
                                    :center="centerGmap"
                                    :zoom="zoom"
                                    map-type-id="terrain"
                                    style="width: 100%; min-height: 500px"
                                >
                                    <GmapCluster>
                                        <gmap-marker v-for="(m, index) in markers"
                                            :position="m.lat ? m : {lat: 0.00000 , lng: 0.0000}"
                                            
                                            :key="index"
                                        ></gmap-marker>
                                    </GmapCluster>
                                </GmapMap>
                            </div>
                        
                                
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import indonesiaJson from '@/assets/adm_1.json'
import "leaflet/dist/leaflet.css"
import GmapCluster from 'vue2-google-maps/src/components/cluster' // replace src with dist if you have Babel issues
export default {
    components : {
        LMap,
        LGeoJson,
        LTileLayer,
        GmapCluster
    },
    props : ['activityData' , 'invokeCenter' , 'data', 'title'],
    mounted () {
        console.log('data', this.data);
        // console.log(this.$options.indonesiaJson)
        // console.log(this.activityData)
        // this.loadMapData ()
        this.markers = [this.data]
        console.log(this.data)
        this.centerGmap = {lat : this.data.lat , lng : this.data.lng}

        // this.loadMapData()
        // console.log(this.markers)
    },
    watch : {
        data : function (){
            this.loadMapData()
        },
        invokeCenter : function () {
            // console.log(this.invokeCenter)
            this.centerGmap = {
                lat : this.invokeCenter.lat,
                lng : this.invokeCenter.lng
            }
            this.zoom = 5;
        }
    },
    
    computed : {
        options() {
            return {
                onEachFeature: this.onEachFeatureFunction,
            };
        },
    },
    data () {
        return {
            zoom : 12,
            markers : [],
            center : [-2.957026, 117.761289],
            // centerGmap : {lat : -2.757026 , lng : 116.761289},
            centerGmap : null,
            indonesiaJson : null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },
    indonesiaJson : null,
    methods : {
        onEachFeatureFunction() {
            return (feature, layer) => {
                layer.bindTooltip(
                    `${feature.properties}`
                ,
                { permanent: false, sticky: true }
                );
                
            };
            
        },
        styleOptions(feature) {
            return {
                fillColor: '#E3242B',
                weight: 2,
                opacity: 1,
                color: '#333',
                fillOpacity: feature.properties.opacity ? feature.properties.opacity : 0 // Replace 'intensity' with your actual property
            };
        },
        async loadMapData () {
            // try {
            //     let resp = await this.$http.get('/api/highlight/map?level=provinsi')

            //     console.log(indonesiaJson)

            //     // console.log(resp.data.data)
            //     let data = resp.data.data

            //     const sum = data.reduce((total, item) => total + parseInt(item.distribution), 0);

            //     // indonesiaJson.features.map(x => x.properties.opacity)

            //     for(var i in data) {
            //         let curData = data[i]
            //         let index = indonesiaJson.features.findIndex(x => x.properties.ADM1_PCODE == curData.kode_provinsi)

            //         indonesiaJson.features[index].properties.opacity = parseInt(curData.distribution) / sum
            //     }

            //     this.indonesiaJson = indonesiaJson

            // }
            // catch(err) {
            //     console.log(err)
            // }
            this.indonesiaJson = null
            let mapData = JSON.parse(JSON.stringify(indonesiaJson))
            console.log(this.data)

            
            

            for(var i in this.data) {
                let curData = this.data[i]
                if(!curData) continue
                console.log(curData)
                // console.log
                let index = indonesiaJson.features.findIndex(x => x.properties.ADM1_PCODE == curData.kode_provinsi)
                console.log(index)
                if(index == -1) continue

                mapData.features[index].properties.opacity = curData.percentage / 100 * 2.2
                // console.log(mapData.features[i].properties.opacity)
            }

            this.indonesiaJson = mapData


            
        }
    }
}
</script>

<style>
    .leaflet-container{
        background-color: #FFF;
    }
</style>